// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"80056a7e","879":"ebbd95de"}[chunkId] + ".chunk.js";
};